import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const RightArrow = memo<ISvgProps>((props, { className }) => (
  <Svg className={className} width="20" height="20" viewBox="0 0 20 20" {...props}>
    <g id="arrow" transform="translate(0 20) rotate(-90)">
      <rect id="Rectangle_4413" data-name="Rectangle 4413" width="20" height="20" fill="none" />
      <path
        id="Path_21465"
        data-name="Path 21465"
        d="M9.668-10.726a.688.688,0,0,0,.284-.06.705.705,0,0,0,.241-.181l5.163-5.27a.693.693,0,0,0,.206-.5.7.7,0,0,0-.092-.359.678.678,0,0,0-.252-.252.7.7,0,0,0-.359-.092.742.742,0,0,0-.511.206L9.32-12.075h.689L4.973-17.232a.7.7,0,0,0-.5-.206.7.7,0,0,0-.359.092.678.678,0,0,0-.252.252.7.7,0,0,0-.092.359.65.65,0,0,0,.057.273.84.84,0,0,0,.149.224L9.128-10.96A.758.758,0,0,0,9.668-10.726Z"
        transform="translate(0.219 24.24)"
        fill="rgba(0,0,0,0.25)"
      />
    </g>
  </Svg>
));

RightArrow.displayName = 'RightArrow';

export default RightArrow;
